import React from 'react';
import { IconButton } from 'react-native-paper';

import MedalFirstPlace from '../../assets/medal-first-place-stroke-rounded.svg';
import MedalSecondPlace from '../../assets/medal-second-place-stroke-rounded.svg';
import MedalThirdPlace from '../../assets/medal-third-place-stroke-rounded.svg';

const RankIcon = ({ rank, ...props }) => {
  if (rank === 1) {
    return <IconButton {...props} iconColor="#edcb0f" icon={MedalFirstPlace} />;
  }
  if (rank === 2) {
    return <IconButton {...props} iconColor="#c0c0c0" icon={MedalSecondPlace} />;
  }
  if (rank === 3) {
    return <IconButton {...props} iconColor="#ce8946" icon={MedalThirdPlace} />;
  }
  // PalmaresTab also has a case for rank === 5, but EventCardView doesn't.
  // For reusability, let's include it.
  if (rank === 5) {
    return <IconButton {...props} icon="numeric-5-circle" />;
  }
  return <IconButton {...props} icon="trophy" />;
};

export default RankIcon;